import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Avatar from 'material-ui/Avatar';
import {List, ListItem} from 'material-ui/List';
import moment from 'moment'
import {closeBookingForm, updateBookingField, updateBooking, deleteBooking} from '../../actions/bookings'

const rootStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
}

const list = {
    width: '100%',
    height: 400,
    overflowY: 'auto',
}

const leftPanelStyle = {
  float: 'left',
  width: '50%'
}

const rightPanelStyle = {
  float: 'right',
  padding: 10,
  width: '45%'
}

class AddBooking extends Component {

  static defaultProps = {

  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeBookingForm())
  }

  updateBooking() {
    const { dispatch } = this.props
    dispatch(updateBooking(this.props.booking))
  }

  deleteBooking() {
    const { dispatch } = this.props
    dispatch(deleteBooking(this.props.booking))
  }

  updateBookingField(name, event, date) {
    const { dispatch } = this.props
    dispatch(updateBookingField(name, date))
  }

  render() {

    if (this.props.booking) {
      var actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.closeDialog.bind(this)}
        />,
        <FlatButton
          label={"Cancel Booking"}
          secondary={true}
          onClick={this.deleteBooking.bind(this)}
        />,
      ];

      return (<Dialog
        actions={actions}
        title="Booking"
        modal={true}
        open={this.props.booking != null}>
          <div style={leftPanelStyle}>
            <strong>User : </strong>{this.props.booking.user.fullName + " ( " + this.props.booking.user.email + " )"}
            <br />
            <strong>Start: </strong>{moment(this.props.booking.startDate).toDate().toString()}
            <br />
            <strong>End: </strong>{moment(this.props.booking.endDate).toDate().toString()}
            <br />
          </div>
          <div style={rightPanelStyle}>
            {this.props.booking.invitees.length > 0 ?
            (<div><strong>Invitees</strong>
            <div style={rootStyle}>
            <List style={list}>
              {this.props.booking.invitees.map((invite, index) =>
                <ListItem
                  primaryText={invite.user.email + " (" + invite.status + ")"}
                  leftAvatar={<Avatar src={invite.user.image} />}
                />
              )}
            </List></div></div>) : (<strong>No Invitees</strong>)}
          </div>
      </Dialog>)
    } else {
      return (<div />)
    }
  }
}

const mapStateToProps = state => {
  return state.locationsReducer
}

export default withRouter(
  connect(mapStateToProps)(AddBooking)
);



// WEBPACK FOOTER //
// ./src/components/locations/AddBooking.js